<div class="row page-header">
    <div class="col-12">
        <h1>
            Manpower Outliers
            <small>Jobs in the 100% manpower metric. Exclude a job to leave it out of Manpower within bid (excl. outliers).</small>
        </h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <p class="text-muted manpower-outlier-note">
                Highlighted rows are at least 100% over bid or move the company metric by about 5 points. The original manpower metric is unchanged.
            </p>
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="false"
                            [showEdit]="true"
                            [showDelete]="false"
                        ></action-toolbar-buttons>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Manpower Outliers'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        (formatItem)="onFormatItem($event)"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Exclude'" [binding]="'excluded'" [dataType]="'Boolean'" [width]="90" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobDisplay'" [width]="'*'" [minWidth]="220" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Estimated hours'" [binding]="'estimatedHours'" [format]="'n1'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Projected hours'" [binding]="'projectedHours'" [format]="'n1'" [width]="140" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'% over bid'" [binding]="'percentOverBid'" [format]="'p1'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Points added'" [binding]="'pointsAdded'" [format]="'p1'" [width]="120" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Reason'" [binding]="'reason'" [width]="220" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Effective date'" [binding]="'effectiveOn'" [format]="'d'" [width]="130" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Excluded by'" [binding]="'createdByUserId'" [dataMap]="userMap" [width]="160" [isReadOnly]="true"></wj-flex-grid-column>
                    </wj-flex-grid>
                </div>
            </div>
        </div>
    </div>
</div>
